import React from 'react';
import { SetCloserForm } from './SetCloserForm';
import { HeaderTextTW } from '../../../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { useGetEmdAmount } from './hooks/useGetEmdAmount';
import { Currency } from '../../../../../../ui-toolkit';
import { SetRecipientForm } from './SetRecipientForm';
import { CloserAlert } from './CloserAlert';

export const CreateEmdPasscode: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const { emdAmount = 0 } = useGetEmdAmount();

  return (
    <div className={'flex w-full flex-col gap-4 '}>
      <CloserAlert />
      <div>
        <HeaderTextTW>Earnest Money Deposit</HeaderTextTW>
        <Currency data-test-id={'emd-amount'} value={emdAmount} />
      </div>
      <SetRecipientForm onClose={onClose}>
        <SetCloserForm />
      </SetRecipientForm>
    </div>
  );
};
